import type { CardAttributeDto } from "../../types/CardAttributeDto";
import type { CardAttributeEntity } from "../../types/CardAttributeEntity";

export const CardAttributeDtoToEntity = ({ ...rest }: Readonly<CardAttributeDto>): CardAttributeEntity => {
    return { ...rest };
};
